import { FlexBoxCol, FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { getTextWithTag } from '~/src/helpers/getTextWithTag';
import { isHtmlWithText } from '~/src/helpers/isHtmlWithText';
import * as ST from './styled';

export interface ITextBlockProps {
    blockId: string;
    text: string;
    customStyles?: ST.ITextBlockStyles;
    background?: string;
    additionalBlockConfig?: any;
    tag?: string;
}

const TextBlock = ({ blockId, text, customStyles, background, additionalBlockConfig, tag }: ITextBlockProps): JSX.Element => {
    const textWithTag = getTextWithTag(text, tag);

    return (
        <ST.Wrapper id={blockId} background={background} {...customStyles} {...additionalBlockConfig}>
            <ST.Grid modeName='wide'>
                <FlexBoxRow>
                    <FlexBoxCol xs={12}>
                        {isHtmlWithText(text) && (
                            <ST.Text {...customStyles} dangerouslySetInnerHTML={{ __html: textWithTag }} />
                        )}
                    </FlexBoxCol>
                </FlexBoxRow>
            </ST.Grid>
        </ST.Wrapper>
    );
};

export default TextBlock;
